import { useScreenSize, ScreenSize } from '@/ui/hooks/useScreenSize';
import { translate } from '@/domain/utils/translate';
import IconList from '@/ui/components/IconList';

/**
 * Detallar componente
 * @component
 */
const OptionsEmptyList = () => {
  /**
   * Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido
   */
  const { width, maxLargeWidth }: ScreenSize = useScreenSize();
  /** Variable que define si es entorno mobile o desktop */
  const isMobile: boolean = width < maxLargeWidth;
  return (
    <ul className="list-unstyled svg-primary-1 text-secondary-1">
      <IconList
        classIcon='pe-3'
        classMain="p-2 my-1"
        iconName={'ico-success'}
        classTitle={`${isMobile ? 'p-regular' : 'p-large'}`}
        title={translate('store.empty_list_text_1')}
      />
      <IconList
        classIcon='pe-3'
        classMain="p-2 my-1"
        iconName={'ico-success'}
        classTitle={`${isMobile ? 'p-regular' : 'p-large'}`}
        title={translate('store.empty_list_text_2')}
      />
      <IconList
        classIcon='pe-3'
        classMain="p-2 my-1"
        iconName={'ico-success'}
        classTitle={`${isMobile ? 'p-regular' : 'p-large'}`}
        title={translate('store.empty_list_text_3')}
      />
      <IconList
        classIcon='pe-3'
        classMain="p-2 my-1"
        iconName={'ico-success'}
        classTitle={`${isMobile ? 'p-regular' : 'p-large'}`}
        title={translate('store.empty_list_text_4')}
      />
    </ul>
  );
};

export default OptionsEmptyList;
